import type { TutorialStep } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";

import Tutorial from "~/components/Tutorial";
import { useAccess } from "~/hooks";

const CoursesTutorial = () => {
	const { isMember } = useAccess();
	const { isLoaded } = useAuth();

	const steps: TutorialStep[] = [
		{
			content:
				'This is the "All Courses" dashboard. You can use this menu to choose a specific certification at any time.',
			target: "#certification-select",
			disableScrolling: true,
		},

		{
			content:
				"You can select the course approval required for your profession; however, many organizations approve all of our courses.",
			target: "#accreditation-filter",
		},

		{
			content: "Filter courses by categories.",
			target: ".course-category",
		},
		{
			content: "Or, search all courses by keyword.",
			target: ".search-btn-full",
		},

		{
			content:
				'Use this button to select "All Courses" as your default homepage.',
			target: ".courses-select-btn",
		},

		{
			content: "Like courses to save them for later.",
			target: "#course-like-btn",
		},

		{
			content: "Share courses with friends and colleagues.",
			target: "#course-share-btn",
		},

		isMember
			? {
					content: "Take your first course to start earning credits!",
					target: ".course-card",
				}
			: {
					content: "Become a member today to start earning credits!",
					target: ".sidebar-cta",
				},
	];

	if (!isLoaded) return null;

	return (
		<Tutorial
			steps={steps}
			tutorialKey="allCoursesTutorial"
			trackingEventTitle="All Courses Tutorial"
		/>
	);
};

export default CoursesTutorial;
